module.exports = __webpack_public_path__ + "img/evolution.142d5a2b.jpg";